import { render, staticRenderFns } from "./symbiote.vue?vue&type=template&id=20227458&scoped=true&"
import script from "./symbiote.vue?vue&type=script&lang=js&"
export * from "./symbiote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20227458",
  null
  
)

export default component.exports